<template>
  <a-modal
    title="预览"
    :visible="visible"
    @ok="handleGetData"
    @cancel="handleCancel"
    okText="获取数据"
    cancelText="关闭"
    style="top:20px;"

    :width="`${previewWidth}px`"
  >
    <k-build-form
      :jsonData="jsonData"
      @submit="handleSubmit"
      ref="kBuildForm"
    />
    <vxe-grid
      border
      stripe
      resizable
      highlight-hover-column
      highlight-current-column
      highlight-hover-row
      highlight-current-row
      show-overflowd
      export-config
      height="750"
      :loading="loading"
      :toolbar="tableToolbar"
      :data="tableData"
      :sort-config="{trigger: 'cell'}"
      :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
      @sort-change="sortChangeEvent"
      @toolbar-button-click="toolbarButtonClickEvent">
      <!--eslint-disable-next-line-->
      <div v-for="item in tableColumn">
        <vxe-table-column
          :type="item.type"
          :field="item.field"
          :title="item.title"
          :visible="item.visible"
          :width="item.width"
          :fixed="item.fixed"
          :showOverflow="item.showOverflow"
          :formatter="item.formatter"
          :sortable="item.sortable"
          :filters="[{data: {vals: [], sVal: '', fMenu: '', f1Type:'', f1Val: '', fMode: 'and', f2Type: '', f2Val: ''}}]"
          :filter-render="{name: 'FilterExcel'}">
        </vxe-table-column>
      </div>
    </vxe-grid>
    <a-pagination
      @showSizeChange="handleSizeChange"
      @change="handleCurrentChange"
      v-model="tablePage.currentPage"
      :page-size-options="['5', '10', '15', '20', '50', '100', '150', '200','1000','2000','5000','10000','100000']"
      :page-size="tablePage.pageSize"
      :total="tablePage.totalResult"
      showSizeChanger
      showQuickJumper>
    </a-pagination>
    <jsonModel ref="jsonModel" />
  </a-modal>
</template>
<script>
import jsonModel from './jsonModal'
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import { post } from '@/api/Api'
import api from '@/api'

export default {
    name: 'PreviewModal',
    data() {
      return {
        visible: false,
        previewWidth: 850,
        jsonData: {},
        tableData: [],
        loading: false,
        tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0
        },
        tableToolbar: {
          buttons: [
            { code: 'query', name: 'button.query' },
            { code: 'reset', name: 'button.reset' }
          ],
          zoom: true,
          custom: true,
          export: true,
          resizable: {
            storage: true
          }
        },
        validRules: null,
        tableColumn: [],
        paramModel: {}
      }

    },
    components: {
      jsonModel
    },
    created() {

    },
    methods: {
      handleSubmit(p) {
        p.then(res => {
          console.log(res, '获取数据成功')
          this.$refs.jsonModel.jsonData = res
          this.$refs.jsonModel.visible = true
        }).catch(err => {
          console.log(err, '获取数据失败')
        })
      },
      handleGetData() {
        this.$refs.kBuildForm
          .getData()
          .then(res => {
            console.log(res, '获取数据成功')
            this.$refs.jsonModel.jsonData = res
            this.$refs.jsonModel.visible = true
          })
          .catch(err => {
            console.log(err, '获取数据失败')
          })
      },
      handleCancel() {
        this.visible = false
      },
      toolbarButtonClickEvent({ code }, event) {
        switch (code) {
          case 'query':
            const params = this.$refs.kBuildForm.getFieldsValue()
            Object.keys(this.paramModel).forEach(k => {
              // paramModel.set(k,params.get(k)?params.get(k):'')
              this.paramModel[k] = params[k] === undefined ? '' : params[k]
            })
            console.log(this.paramModel, 'paramModel')
            this.findList()
            break
          case 'reset':
            this.handleReset()
        }
      },
      handleCurrentChange({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.findList()
      },
      handleSizeChange(current, size) {
        this.tablePage.pageSize = size
        this.findList()
      },
      findList() {
        this.loading = true
        const parameter = {
          warehouse: Vue.ls.get(WAREHOUSE),
          query: true,
          executor: Vue.ls.get(OPERATOR),
          no: this.jsonData.dataSource.no,
          args: this.paramModel
        }
        post(api.adminQuery, {}, parameter)
          .then((body) => {
            const result = body
            this.tablePage.totalResult = result.length
            this.tableData = result.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize)
            this.loading = false
          }).catch(e => {
          this.loading = false
        })
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      sortChangeEvent({ column, property, order }) {
        console.info(property, order)
      }
    }
  }
</script>
